import { render, staticRenderFns } from "./SpecialCourseConfig.vue?vue&type=template&id=610fcd37"
import script from "./SpecialCourseConfig.vue?vue&type=script&lang=js"
export * from "./SpecialCourseConfig.vue?vue&type=script&lang=js"
import style0 from "../../style/course-config-page.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports